import {formatMoney, throttle, debounce} from "//toleofficial.com/cdn/shop/t/60/assets/theme.js?v=96670023023759800021773230634";

 /*============================================================================
    CountdownTimer
  ==============================================================================*/
  
class CountdownTimer extends HTMLElement {
  constructor() {
    super();
    this.el = this;
    this.display = this.querySelector('[data-time-display]');
    this.block = this.closest('.countdown__block--timer');
    this.year = this.el.dataset.year;
    this.month = this.el.dataset.month;
    this.day = this.el.dataset.day;
    this.hour = this.el.dataset.hour;
    this.minute = this.el.dataset.minute;
    this.daysPlaceholder = this.querySelector('[date-days-placeholder]');
    this.hoursPlaceholder = this.querySelector('[date-hours-placeholder]');
    this.minutesPlaceholder = this.querySelector('[date-minutes-placeholder]');
    this.secondsPlaceholder = this.querySelector('[date-seconds-placeholder]');
    this.messagePlaceholder = this.querySelector('[data-message-placeholder]');
    this.hideTimerOnComplete = this.el.dataset.hideTimer;
    this.completeMessage = this.el.dataset.completeMessage;

    this.timerComplete = false;

    this.init();
  }

  init() {
    setInterval(() => {
      if (!this.timerComplete) {
        this._calculate();
      }
    }, 1000);
  }

  _calculate() {
    // Find time difference and convert to integer
    const timeDifference = +new Date(`${this.month}/${this.day}/${this.year} ${this.hour}:${this.minute}:00`).getTime() - +new Date().getTime();
    // If time difference is greater than 0, calculate remaining time
    if (timeDifference > 0) {
      const intervals = {
        days: this._formatNumber(Math.floor(timeDifference / (1000 * 60 * 60 * 24))),
        hours: this._formatNumber(Math.floor((timeDifference / (1000 * 60 * 60)) % 24)),
        minutes: this._formatNumber(Math.floor((timeDifference / 1000 / 60) % 60)),
        seconds: this._formatNumber(Math.floor((timeDifference / 1000) % 60)),
      };

      this.daysPlaceholder.innerHTML = intervals.days;
      this.hoursPlaceholder.innerHTML = intervals.hours;
      this.minutesPlaceholder.innerHTML = intervals.minutes;
      this.secondsPlaceholder.innerHTML = intervals.seconds;

      setTimeout(() => {
        this.display.classList.add('countdown__display--loaded');
      }, 1);
    } else {
      if (this.completeMessage && this.messagePlaceholder) {
        this.messagePlaceholder.classList.add('countdown__timer-message--visible');
      }

      if (this.hideTimerOnComplete === 'true') {
        this.display.classList.remove('countdown__display--visible');
        this.display.classList.add('countdown__display--hidden');
      }

      if (!this.completeMessage && this.hideTimerOnComplete === 'true') {
        this.block.classList.add('countdown__block--hidden');
      }

      this.timerComplete = true;
    }
  }

  _formatNumber(number) {
    return number < 10 ? '0' + number : number;
  }
}

customElements.define('countdown-timer', CountdownTimer);
 
class Redirector {
  constructor() {
      this.defaultStatusCode = 302; 
  }

  /**
   * Redirects from one specific URL or path to another.
   * @param {string} fromUrl - The URL or path to match for redirection.
   * @param {string} toUrl - The URL or path to redirect to.
   */
  redirect(fromUrl, toUrl) {
    try {
        const currentUrl = window.location.href;
        const currentPath = window.location.pathname;
        
        const isFullFromUrl = fromUrl.startsWith('http');
        const isFullToUrl = toUrl.startsWith('http');

        const fromMatch = isFullFromUrl ? currentUrl === fromUrl : currentPath === fromUrl;
        const redirectTo = isFullToUrl ? toUrl : `${window.location.origin}${toUrl}`;

        if (fromMatch) {
            console.log(`Redirecting from ${fromUrl} to ${redirectTo}`);
            window.location.replace(redirectTo);
        }
    } catch (error) {
        this.handleError(error);
    }
  }

  /**
   * Validates the given URL.
   * @param {string} url - The URL to validate.
   * @returns {boolean} - True if the URL is valid, false otherwise.
   */
  isValidUrl(url) {
    try {
        new URL(url, window.location.origin);
        return true;
    } catch (_) {
        return false;
    }
  }

  /**
   * Handles errors that occur during the redirection process.
   * @param {Error} error - The error to handle.
   */
  handleError(error) {
    console.error(`Redirect failed: ${error.message}`);
  }
}


function zoom() {
  let zoom = document.querySelector(".product-gallery__zoom button");
  let galleryImages = document.querySelectorAll(".product-gallery__media");
  if (!zoom) return;

  galleryImages.forEach((image) => {
    image.addEventListener("click", function () {
      zoom.click();
    });
  });
}

function triggerQtyChangeEvent(event, element) {
  const changeEvent = new Event(event, { bubbles: true });
  element.dispatchEvent(changeEvent);
}

function qtyChange() {
  let btns = document.querySelectorAll('#cart-drawer .quantity-selector__button');

  btns.forEach(btn => {
    btn.addEventListener('click', function(){
      console.log('click work')
      let input = this.closest('.qty-box').querySelector('.quantity-input');
      setTimeout(function(){ triggerQtyChangeEvent('change', input); },500);
    });
  });   
}

function arrive(selector, callback, find) {
  const observer = new MutationObserver((mutationsList, observer) => {
    mutationsList.forEach((mutation) => {
      if (mutation.type === "childList") {
        const element = document.querySelector(selector);
        if (
          element &&
          element.shadowRoot &&
          element.shadowRoot.querySelector(find)
        ) {
          callback(element.shadowRoot);
          observer.disconnect();
        }
      }
    });
  });

  observer.observe(document.body, { childList: true, subtree: true });
}

function razorpayWidget() {
  if (!document.body.classList.contains("template-product")) return;

  const selector = "main-component";

  const styleElement = document.createElement("style");

  const cssText = `
      .container {
        max-width: 450px !important;
      }
    `;

  styleElement.textContent = cssText;

  arrive(selector, (shadowRoot) => {
    shadowRoot.appendChild(styleElement);
  }, '.container');
}


// document.addEventListener('variant:change', function(v){
  
//   let container = document.getElementById('selectedVariantInfo');

//   if(!container) return;

//   let op1 = v.detail.variant.option1;
//   let op2 = v.detail.variant.option2;
//   let op3 = v.detail.variant.option3;

//   let option_1 = container.querySelector('.option-1');
//   let option_2 = container.querySelector('.option-2');
//   let option_3 = container.querySelector('.option-3');

//   if(option_1) { option_1.innerText = op1; } 
//   if(option_2) { option_2.innerText = op2; } 
//   if(option_3) { option_3.innerText = op3; }   
// });

function klaviyoReview() {
  let reviewItems = document.querySelectorAll('#overallRating');

  if(!reviewItems.length) return;

  reviewItems.forEach(function(reviewItem){
    let review = reviewItem.querySelector('.kl_reviews__star_rating_widget')?.getAttribute('aria-label');
    console.log(review)
  });
}

document.addEventListener("DOMContentLoaded", function () {
  zoom();
  klaviyoReview();

  const redirector = new Redirector();

  redirector.redirect('/collections/shop-all', '/pages/shop-all');
  redirector.redirect('/collections/iphone-case', '/pages/iphone-cases-accessories');
  redirector.redirect('/collections/iphone-accessories', '/pages/iphone-cases-accessories');
  redirector.redirect('/collections/watch-accessories', '/pages/watch-accessories');
  redirector.redirect('/collections/leather-cases', '/pages/leather-cases');
  redirector.redirect('/collections/work-essentials', '/pages/work-essentials');
}); 


window.addEventListener('DOMContentLoaded', () => {
  // 1. Grab the very first image in .grid-product__image
  const firstImg = document.querySelector('.product-list .product-gallery__media img');
  if (!firstImg) return;

  // 2. Put its src onto its parent container’s background
  const container = firstImg.closest('.product-list .product-gallery__media-list');
  container.style.backgroundImage = `url(${firstImg.src})`;

  // 3. IntersectionObserver to tease only that first image
  const observer = new IntersectionObserver((entries, obs) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        // 4. Use the Web Animations API for the three-times tease
        entry.target.animate([
          { transform: 'translateX(0)' },
          { transform: 'translateX(-25%)' },
          { transform: 'translateX(0)' }
        ], {
          duration: 2000,
          easing: 'ease-in-out',
          iterations: 2,
          fill: 'forwards'
        });

        // 5. Stop observing after the first trigger
        obs.unobserve(entry.target);
      }
    });
  }, {
    threshold: 0.1
  });

  // 6. Observe that image
  observer.observe(firstImg);
});




// document.addEventListener('DOMContentLoaded', function() {
//   // Select all quick-buy elements inside the cart-drawer
//   const quickBuyBtns = document.querySelectorAll('.cart-drawer .product-card__quick-buy');
  
//   quickBuyBtns.forEach(function(quickBuyBtn) {
//     quickBuyBtn.addEventListener('click', function(event) {
//       // Prevent default behavior (e.g., if it's a link)
//       event.preventDefault();
      
//       // Scroll the cart-drawer container to the top
//       const cartDrawer = document.querySelector('.cart-drawer__top');
//       if (cartDrawer) {
//         cartDrawer.scrollIntoView();
//       }
//     });
//   });
// });


// (function () {
//   // Conservative Drawer Scroller — less false positives
//   const DRAWER_SELECTOR = '.cart-drawer';
//   const DRAWER_TOP_SELECTOR = '.cart-drawer__top';
//   const USER_ACTION_WINDOW_MS = 5000; // consider network results user-related if user acted within this time
//   const SCROLL_THROTTLE_MS = 1000;
//   const DEBUG = false; // set true to see console debug logs

//   function dlog(...args) { if (DEBUG) console.debug('[drawer-scroll]', ...args); }

//   let lastUserInteraction = 0;
//   let lastScrollAt = 0;
//   let scrollTimer = null;

//   function isDrawerVisible(drawer) {
//     if (!drawer) return false;
//     const style = getComputedStyle(drawer);
//     if (style.display === 'none' || style.visibility === 'hidden' || style.opacity === '0') return false;
//     const r = drawer.getBoundingClientRect();
//     return r.width > 0 && r.height > 0;
//   }

//   function doScroll() {
//     const now = Date.now();
//     if (now - lastScrollAt < SCROLL_THROTTLE_MS) {
//       dlog('Skipping scroll — throttled');
//       return;
//     }
//     const top = document.querySelector(DRAWER_TOP_SELECTOR);
//     const drawer = document.querySelector(DRAWER_SELECTOR);
//     if (!top) { dlog('No drawer top element found, abort'); return; }
//     if (!isDrawerVisible(drawer)) { dlog('Drawer not visible, abort'); return; }

//     try {
//       top.scrollIntoView({ behavior: 'smooth', block: 'start' });
//       lastScrollAt = Date.now();
//       dlog('Performed scroll into view');
//     } catch (err) { dlog('scrollIntoView failed', err); }
//   }

//   function scheduleScroll(delay = 80, reason = '') {
//     dlog('scheduleScroll called', { delay, reason });
//     clearTimeout(scrollTimer);
//     scrollTimer = setTimeout(() => doScroll(), delay);
//   }

//   // Allowed user-trigger selectors (tight — add your theme's add-to-cart / quick-buy classes if different)
//   const USER_ACTION_SELECTORS = [
//     '.product-card__quick-buy'
//   ];
//   function isUserActionTarget(el) {
//     if (!el) return false;
//     for (const sel of USER_ACTION_SELECTORS) {
//       if (el.closest && el.closest(sel)) return true;
//     }
//     return false;
//   }

//   // Track trusted user interactions (clicks / explicit input changes)
//   document.addEventListener('click', function (e) {
//     try {
//       if (e.isTrusted && isUserActionTarget(e.target)) {
//         lastUserInteraction = Date.now();
//         dlog('user click on add/quick-buy detected', { time: lastUserInteraction });
//         // schedule scroll conservatively — rarely immediate; network will confirm
//         scheduleScroll(140, 'user-click-add');
//       }
//     } catch (err) { dlog('click handler error', err); }
//   }, true);

//   document.addEventListener('change', function (e) {
//     try {
//       // only treat quantity inputs typed/changed by user inside drawer as intent
//       if (e.isTrusted && (e.target.matches && (e.target.matches('input.quantity-input[is="quantity-input"]') || e.target.matches('.cart__qty-input')))) {
//         lastUserInteraction = Date.now();
//         dlog('user change on quantity input detected', { time: lastUserInteraction });
//         scheduleScroll(120, 'user-quantity-change');
//       }
//     } catch (err) { dlog('change handler error', err); }
//   }, true);

//   // Conservative fetch interception: only consider explicit cart endpoints
//   (function interceptFetch() {
//     if (window.__drawerScrollFetchIntercept) return;
//     window.__drawerScrollFetchIntercept = true;
//     const origFetch = window.fetch;
//     window.fetch = function (...args) {
//       try {
//         const input = args[0];
//         const url = (input && (input.url || input.toString())) || '';
//         const isCartEndpoint = /\/cart(\/|\.|$)|cart\.(js|json)|cart\/add|cart\/change|cart\/update|\/cart\/clear/i.test(url);
//         if (isCartEndpoint) {
//           dlog('fetch to cart endpoint intercepted', url);
//           // only schedule automatically if user acted recently OR request is clearly add/change
//           const now = Date.now();
//           const recentUser = (now - lastUserInteraction) < USER_ACTION_WINDOW_MS;
//           const mustScroll = recentUser || /add|change|update|cart\.js|cart\.json/i.test(url);
//           return origFetch.apply(this, args).then(res => {
//             if (mustScroll) scheduleScroll(140, 'fetch-cart-endpoint');
//             return res;
//           }).catch(err => {
//             if (mustScroll) scheduleScroll(140, 'fetch-cart-endpoint-error');
//             throw err;
//           });
//         }
//       } catch (e) { dlog('fetch intercept check failed', e); }
//       return origFetch.apply(this, args);
//     };
//   })();

//   // Conservative XHR interception
//   (function interceptXHR() {
//     if (window.__drawerScrollXhrIntercept) return;
//     window.__drawerScrollXhrIntercept = true;
//     const origOpen = XMLHttpRequest.prototype.open;
//     XMLHttpRequest.prototype.open = function (method, url) {
//       try {
//         if (url && /\/cart(\/|\.|$)|cart\.(js|json)|cart\/add|cart\/change|cart\/update|\/cart\/clear/i.test(url)) {
//           this.addEventListener('load', function () {
//             const now = Date.now();
//             const recentUser = (now - lastUserInteraction) < USER_ACTION_WINDOW_MS;
//             if (recentUser || /add|change|update|cart\.js|cart\.json/i.test(url)) {
//               dlog('XHR cart endpoint load detected', method, url);
//               scheduleScroll(140, 'xhr-cart-endpoint');
//             }
//           });
//         }
//       } catch (e) { dlog('XHR intercept error', e); }
//       return origOpen.apply(this, arguments);
//     };
//   })();

//   // MutationObserver: only trigger scroll when nodes added/removed actually look like cart rows
//   (function observeMutations() {
//     const root = document.body;
//     if (!root) return;
//     const mo = new MutationObserver((mutations) => {
//       try {
//         for (const m of mutations) {
//           // check added nodes for cart-like elements
//           if (m.addedNodes && m.addedNodes.length) {
//             for (const node of m.addedNodes) {
//               if (node.nodeType !== 1) continue;
//               // Look for common cart row selectors / quantity inputs inside added nodes
//               if (node.matches && (node.matches('.cart-item, .cart__row, .cart-item-row, .cart-item-wrapper') ||
//                                    node.querySelector && (node.querySelector('input[name="quantity"], input.quantity-input, .cart__qty-input')))) {
//                 dlog('MutationObserver saw cart-like node added', node);
//                 scheduleScroll(80, 'mutation-cart-added');
//                 return;
//               }
//             }
//           }
//           // check removed nodes similarly
//           if (m.removedNodes && m.removedNodes.length) {
//             for (const node of m.removedNodes) {
//               if (node.nodeType !== 1) continue;
//               if (node.matches && (node.matches('.cart-item, .cart__row, .cart-item-row, .cart-item-wrapper') ||
//                                    node.querySelector && (node.querySelector('input[name="quantity"], input.quantity-input, .cart__qty-input')))) {
//                 dlog('MutationObserver saw cart-like node removed', node);
//                 scheduleScroll(80, 'mutation-cart-removed');
//                 return;
//               }
//             }
//           }
//           // also if the mutation target itself is inside the drawer and seems cart-related
//           if (m.target && (m.target.closest && m.target.closest(DRAWER_SELECTOR))) {
//             // be conservative: only scroll if change includes quantity inputs or cart rows
//             if ((m.target.querySelector && (m.target.querySelector('input.quantity-input, input[name="quantity"], .cart__qty-input') ||
//                                             m.target.querySelector('.cart-item, .cart__row')))) {
//               dlog('Mutation target inside drawer contains cart nodes', m.target);
//               scheduleScroll(80, 'mutation-target-inside-drawer');
//               return;
//             }
//           }
//         }
//       } catch (err) { dlog('MutationObserver handler error', err); }
//     });

//     mo.observe(root, { childList: true, subtree: true, attributes: false });
//     dlog('MutationObserver attached (conservative filters)');
//   })();

//   // Common theme events — still conservative: only act if user interacted recently
//   ['cart:refresh', 'cart:updated', 'ajaxCart:updated', 'cart:refresh:complete', 'shopify:section:load', 'cart:update'].forEach(ev => {
//     document.addEventListener(ev, function (e) {
//       const now = Date.now();
//       const recentUser = (now - lastUserInteraction) < USER_ACTION_WINDOW_MS;
//       dlog('Theme event fired', ev, 'recentUser:', recentUser);
//       if (recentUser) scheduleScroll(80, 'theme-event:' + ev);
//     });
//   });

//   // Expose small debug helper on window (optional)
//   window.__drawerScrollerDebug = function (on) {
//     if (typeof on === 'boolean') { window.__drawerScrollerDebugFlag = !!on; }
//     return {
//       lastUserInteraction,
//       lastScrollAt,
//       isDrawerVisible: isDrawerVisible(document.querySelector(DRAWER_SELECTOR))
//     };
//   };

//   dlog('Conservative drawer scroller initialized');
// })();



(function () {
  // Only-scroll-on-quick-buy script
  const DRAWER_TOP_SELECTOR = '.cart-drawer__top';
  const QUICK_BUY_SELECTOR = '.product-card__quick-buy:has(form)';
  const USER_ACTION_WINDOW_MS = 7000; // how long a later network/mutation is considered related to the quick-buy
  const SCROLL_THROTTLE_MS = 1000;
  const DEBUG = false;

  function dlog(...args) { if (DEBUG) console.debug('[quick-buy-scroll]', ...args); }

  let lastQuickBuyAt = 0;
  let lastScrollAt = 0;
  let scrollTimer = null;

  function canScrollNow() {
    const now = Date.now();
    if (now - lastScrollAt < SCROLL_THROTTLE_MS) { dlog('throttled'); return false; }
    const top = document.querySelector(DRAWER_TOP_SELECTOR);
    if (!top) { dlog('no top element'); return false; }
    // check drawer visibility via top's closest scroll container if necessary (best-effort)
    const drawer = top.closest && top.closest('.cart-drawer') || document.querySelector('.cart-drawer');
    if (drawer) {
      const r = drawer.getBoundingClientRect();
      if (r.width === 0 && r.height === 0) { dlog('drawer hidden'); return false; }
    }
    return true;
  }

  function doScroll() {
    if (!canScrollNow()) return;
    const top = document.querySelector(DRAWER_TOP_SELECTOR);
    try {
      top.scrollIntoView({ behavior: 'smooth', block: 'start' });
      lastScrollAt = Date.now();
      dlog('scrolled');
    } catch (err) { dlog('scroll failed', err); }
  }

  function scheduleScroll(delay = 120, reason = '') {
    dlog('scheduleScroll', { delay, reason });
    clearTimeout(scrollTimer);
    scrollTimer = setTimeout(doScroll, delay);
  }

  // 1) Track only quick-buy clicks
  document.addEventListener('click', function (e) {
    try {
      const btn = e.target.closest && e.target.closest(QUICK_BUY_SELECTOR);
      if (!btn) return;
      // mark the quick-buy click time
      lastQuickBuyAt = Date.now();
      dlog('quick-buy clicked', lastQuickBuyAt);
      // schedule a deferred scroll so UI that runs immediately after click can start
      scheduleScroll(180, 'quick-buy-immediate');
    } catch (err) { dlog('click handler error', err); }
  }, true);

  // 2) Intercept fetch: only react if it touches cart endpoints AND quick-buy happened recently
  (function interceptFetch() {
    if (window.__quickBuyFetchIntercept) return;
    window.__quickBuyFetchIntercept = true;
    const origFetch = window.fetch;
    window.fetch = function (...args) {
      try {
        const input = args[0];
        const url = (input && (input.url || input.toString())) || '';
        const isCartEndpoint = /\/cart(\/|\.|$)|cart\.(js|json)|cart\/add|cart\/change|cart\/update|\/cart\/clear/i.test(url);
        if (isCartEndpoint) {
          const now = Date.now();
          const recent = (now - lastQuickBuyAt) < USER_ACTION_WINDOW_MS;
          dlog('fetch to cart endpoint', url, 'recentQuickBuy:', recent);
          return origFetch.apply(this, args).then(res => {
            if (recent) scheduleScroll(160, 'fetch-cart-related');
            return res;
          }).catch(err => {
            if (recent) scheduleScroll(160, 'fetch-cart-related-error');
            throw err;
          });
        }
      } catch (e) { dlog('fetch intercept error', e); }
      return origFetch.apply(this, args);
    };
  })();

  // 3) Intercept XHR: same conservative rule
  (function interceptXHR() {
    if (window.__quickBuyXhrIntercept) return;
    window.__quickBuyXhrIntercept = true;
    const origOpen = XMLHttpRequest.prototype.open;
    XMLHttpRequest.prototype.open = function (method, url) {
      try {
        if (url && /\/cart(\/|\.|$)|cart\.(js|json)|cart\/add|cart\/change|cart\/update|\/cart\/clear/i.test(url)) {
          this.addEventListener('load', function () {
            const now = Date.now();
            const recent = (now - lastQuickBuyAt) < USER_ACTION_WINDOW_MS;
            dlog('XHR cart endpoint load', method, url, 'recentQuickBuy:', recent);
            if (recent) scheduleScroll(160, 'xhr-cart-related');
          });
        }
      } catch (e) { dlog('xhr intercept error', e); }
      return origOpen.apply(this, arguments);
    };
  })();

  // 4) MutationObserver: only trigger if quick-buy happened recently AND added/removed nodes look cart-related
  (function observeMutations() {
    const root = document.body;
    if (!root) return;
    const mo = new MutationObserver((mutations) => {
      try {
        const now = Date.now();
        const recent = (now - lastQuickBuyAt) < USER_ACTION_WINDOW_MS;
        if (!recent) return; // ignore unrelated DOM updates
        for (const m of mutations) {
          if (m.addedNodes && m.addedNodes.length) {
            for (const node of m.addedNodes) {
              if (node.nodeType !== 1) continue;
              if (node.matches && (node.matches('.cart-item, .cart__row, .cart-item-row, .cart-item-wrapper') ||
                                   node.querySelector && node.querySelector('input[name="quantity"], input.quantity-input, .cart__qty-input'))) {
                dlog('mutation saw cart-like added node, scheduling scroll');
                scheduleScroll(90, 'mutation-cart-added');
                return;
              }
            }
          }
          if (m.removedNodes && m.removedNodes.length) {
            for (const node of m.removedNodes) {
              if (node.nodeType !== 1) continue;
              if (node.matches && (node.matches('.cart-item, .cart__row, .cart-item-row, .cart-item-wrapper') ||
                                   node.querySelector && node.querySelector('input[name="quantity"], input.quantity-input, .cart__qty-input'))) {
                dlog('mutation saw cart-like removed node, scheduling scroll');
                scheduleScroll(90, 'mutation-cart-removed');
                return;
              }
            }
          }
        }
      } catch (err) { dlog('MutationObserver handler error', err); }
    });

    mo.observe(root, { childList: true, subtree: true, attributes: false });
    dlog('MutationObserver attached (quick-buy gated)');
  })();

  // 5) Theme events: only act if quick-buy happened recently
  ['cart:refresh', 'cart:updated', 'ajaxCart:updated', 'cart:refresh:complete', 'shopify:section:load', 'cart:update'].forEach(ev => {
    document.addEventListener(ev, function (e) {
      const now = Date.now();
      const recent = (now - lastQuickBuyAt) < USER_ACTION_WINDOW_MS;
      dlog('theme event', ev, 'recentQuickBuy:', recent);
      if (recent) scheduleScroll(80, 'theme-event:' + ev);
    });
  });

  dlog('Quick-buy-only drawer scroller initialized');
})();



document.addEventListener('DOMContentLoaded', () => {
  const observer = new MutationObserver((mutations, obs) => {
    const targetContainer   = document.querySelector('.jdgm-row-stars');
    const elementToMove     = document.querySelector('.jdgm-row-media');
  

    // proceed once everything is present
    if (targetContainer && elementToMove ) {
     // 2. Move the media row
      targetContainer.appendChild(elementToMove);

      

      console.log('✅ All elements moved and ordered correctly');

      obs.disconnect(); // stop observing
    }
  });

  observer.observe(document.body, { childList: true, subtree: true });
});

document.addEventListener('DOMContentLoaded', () => {
  const observer = new MutationObserver((mutations, obs) => {
    const targetContainer   = document.querySelector('.jdgm-row-stars');
  
    const a                 = document.querySelector('.jdgm-rev-widg__summary');
    const b                 = document.querySelector('.jdgm-histogram.jdgm-temp-hidden');
    const c              = document.querySelector('.jdgm-rev-widg__summary-average');

    // proceed once everything is present
    if (targetContainer && a && b  && c) {
      // 1. Wrap a + b
      const wrapper = document.createElement('div');
      wrapper.className = 'my-wrapper';
      wrapper.appendChild(a);
      wrapper.appendChild(b);
      targetContainer.appendChild(wrapper);


      console.log('✅ All elements moved and ordered correctly');
      
      obs.disconnect(); // stop observing
    }
  });

  observer.observe(document.body, { childList: true, subtree: true });
});


document.addEventListener('DOMContentLoaded', () => {
  const observer = new MutationObserver((mutations, obs) => {
    const actionsWrapper    = document.querySelector('.jdgm-widget-actions-wrapper');
    const formWrapper       = document.querySelector('.jdgm-form-wrapper');

    // proceed once everything is present
    if (actionsWrapper && formWrapper) {
      formWrapper.parentNode.insertBefore(actionsWrapper, formWrapper);
      obs.disconnect(); // stop observing
    }
  });
  document.querySelectorAll('.jdgm-histogram__row').forEach(row => {
        const rating = row.dataset.rating;                  // e.g. "5" or "3"
        const star    = row.querySelector('.jdgm-histogram__star');
        if (rating && star) {
          const span = document.createElement('span');
          span.className   = 'rating-badge';                
          span.textContent = rating;
          star.insertBefore(span, star.firstChild);
        }
      });

  observer.observe(document.body, { childList: true, subtree: true });
});


document.addEventListener('DOMContentLoaded', () => {
  const observer = new MutationObserver((mutations, obs) => {
    const   formWrapper  = document.querySelector('.jdgm-rev-widg__sort-wrapper');
    const  actionsWrapper      = document.querySelector('.jdgm-row-search');

    // proceed once everything is present
    if (actionsWrapper && formWrapper) {
      formWrapper.parentNode.insertBefore(actionsWrapper, formWrapper);
      obs.disconnect(); 
    }
  });

  observer.observe(document.body, { childList: true, subtree: true });
});
document.addEventListener('DOMContentLoaded', () => {
  const observer = new MutationObserver((mutations, obs) => {
    // 1. Find the reviews container
    const reviewsContainer = document.querySelector('.jdgm-rev-widg__reviews');
    if (!reviewsContainer) return;  // keep observing until it appears

    // 2. For each profile row inside it, append the badge if not already added
    reviewsContainer.querySelectorAll('.jdgm-row-profile').forEach(profile => {
      // Avoid duplicating the badge
      if (profile.querySelector('.kl_reviews__review__verified')) return;

      // 3. Create your badge element
      const badge = document.createElement('span');
      badge.className = 'kl_reviews__review__verified';
      badge.innerHTML = `
        <img src="https://cdn.shopify.com/s/files/1/0563/8248/8713/files/verify.svg?v=1765367295" width='15px' height='auto'>
        <span>Verified buyer</span>
      `;
      // 4. Append it into the profile row
      profile.appendChild(badge);
    });

    // Once we've injected badges into at least one profile, we can stop observing
    if (reviewsContainer.querySelector('.kl_reviews__review__verified')) {
      obs.disconnect();
      console.log('✅ Verified badges added to jdgm-row-profile elements');
    }
  });

  // Observe the entire document for new nodes
  observer.observe(document.body, { childList: true, subtree: true });
});

document.addEventListener('DOMContentLoaded', () => {
  const targetSelector = '.my-wrapper';
  const actionsSelector = '.jdgm-widget-actions-wrapper';

  function moveIfNeeded() {
    const target = document.querySelector(targetSelector);
    const actions = document.querySelector(actionsSelector);
    if (!target || !actions) return false;

    // If it's already the last child of target, do nothing
    if (actions.parentElement === target && target.lastElementChild === actions) {
      return true;
    }

    console.log('[moveIfNeeded] moving actions. current parent:', actions.parentElement);
    try {
      target.appendChild(actions);
      console.log('[moveIfNeeded] moved — new parent:', actions.parentElement);
      return true;
    } catch (err) {
      console.error('[moveIfNeeded] failed to move:', err);
      return false;
    }
  }

  // Try once immediately
  moveIfNeeded();

  // Observe DOM for re-insertions and run the mover whenever something changes
  const observer = new MutationObserver(mutations => {
    // We only try to move if there are additions/removals (cheap check)
    for (const m of mutations) {
      if (m.addedNodes.length || m.removedNodes.length) {
        moveIfNeeded();
        // don't disconnect — keep watching in case widget re-renders later
        break;
      }
    }
  });

  observer.observe(document.body, { childList: true, subtree: true });

  // Optional fallback: short interval tries for pages that mutate heavily
  let tries = 0;
  const maxTries = 20; // ~10s if interval = 500ms
  const poll = setInterval(() => {
    tries++;
    if (moveIfNeeded() || tries >= maxTries) clearInterval(poll);
  }, 500);
});










// Function to set up the observer
function setupModalObserver() {
  const modal = document.querySelector('.jdgm-write-review-modal');
  
  if (modal) {
    // Check if we already set up an observer for this modal
    if (modal.hasAttribute('data-observer-active')) {
      return true;
    }
    
    // Mark this modal as having an observer
    modal.setAttribute('data-observer-active', 'true');
    
    // Create a MutationObserver to watch for style changes
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.type === 'attributes' && mutation.attributeName === 'style') {
          // Check if display is block
          const displayStyle = window.getComputedStyle(modal).display;
          
          if (displayStyle === 'block') {
            document.body.classList.add('review-open');
          } else {
            document.body.classList.remove('review-open');
          }
        }
      });
    });

    // Start observing the modal for attribute changes
    observer.observe(modal, {
      attributes: true,
      attributeFilter: ['style']
    });

    // Check initial state
    if (window.getComputedStyle(modal).display === 'block') {
      document.body.classList.add('modal-open');
    }
    
    return true; // Modal found and observer set up
  }
  
  return false; // Modal not found yet
}

// Watch for the modal to be added to the DOM
const bodyObserver = new MutationObserver(() => {
  setupModalObserver();
});

// Start watching the body for child additions
bodyObserver.observe(document.body, {
  childList: true,
  subtree: true
});

// Also try immediately in case it's already loaded
setupModalObserver();